import React from "react";
import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

const SubmitBase = styled.button.attrs(
	({
		ariaLabel,
		display,
		left,
		right,
		nomargin,
		margin,
		padding,
		wide,
		type,
		disabledcolor,
		scale,
		fullwidth,
		width,
		widthsmall,
		heightsmall,
		border,
		borderradius,
		justifycontent,
		theme,
		height,
		heightSmall,
		inverted,
	}) => ({
		"aria-labelledby": ariaLabel,
		display: display ? display : "inline-block",
		marginright: left ? "auto" : 0,
		marginleft: right ? "auto" : 0,
		margin: nomargin
			? 0
			: margin
			? margin
			: `0.5rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
		padding: padding ? padding : wide ? "0.1rem 2rem" : "0.125rem 0",
		type: type ? type : "button",
		disabledcolor: disabledcolor ? disabledcolor : theme.colors.lightgrey,
		scale: scale ? scale : "1",
		width: fullwidth ? fullwidth : wide ? "auto" : width ? width : "180px",
		widthsmall: fullwidth ? fullwidth : wide ? "auto" : widthsmall ? widthsmall : "auto",
		heightsmall: heightsmall ? heightsmall : "",
		border: border,
		borderradius: borderradius,
		justifycontent: justifycontent ? justifycontent : "unset",
		height: height ? height : inverted ? "50px" : "58px",

		heightsmall: heightsmall,
	})
)`
	${({ pageloading }) =>
		pageloading &&
		css`
			background-image: url(/static/images/images/three-dots.svg);
			background-position: center;
			background-repeat: no-repeat;
			background-size: 60px;
		`}

	cursor: pointer;
	transition: all 0.2s ease;
	text-decoration: none;
	display: ${({ display }) => display};
	backface-visibility: hidden;
	margin-right: ${({ marginright }) => marginright};
	margin-left: ${({ marginleft }) => marginleft};
	margin: ${({ margin }) => margin};
	padding: ${({ padding }) => padding};
	text-align: center;
	border-radius: 3px;
	overflow: initial;
	border-radius: ${({ borderradius }) => (borderradius ? borderradius : "3px")};
	width: ${({ widthsmall }) => (widthsmall ? widthsmall : "initial")};
	justify-content: ${({ justifycontent }) => justifycontent};
	height: ${({ heightsmall }) => heightsmall};
	width: ${({ width }) => (width ? width : "initial")};

	${media.greaterThan(breakpoints.ipad)`
	height: ${({ height }) => height};

  `}

	&:focus {
		outline-style: solid;
		outline-offset: 5px;
		outline-width: 2px;
	}

	&:disabled {
		background: ${({ disabledcolor }) => disabledcolor};
		cursor: not-allowed;
	}
`;
const Base = styled.a.attrs(
	({
		ariaLabel,
		display,
		left,
		right,
		nomargin,
		margin,
		marginleft,
		smallmarginleft,
		smallmargin,
		padding,
		wide,
		type,
		disabledcolor,
		scale,
		fullwidth,
		width,
		widthsmall,
		border,
		borderradius,
		justifycontent,
		theme,
		minwidth,
		height,
	}) => ({
		"aria-labelledby": ariaLabel,
		display: display ? display : "flex",
		marginright: left ? "auto" : 0,
		marginleft: marginleft ? marginleft : right ? "auto" : 0,
		smallmarginleft: smallmarginleft ? smallmarginleft : right ? "auto" : 0,
		smallmargin: nomargin
			? 0
			: smallmargin
			? smallmargin
			: `2rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
		margin: nomargin
			? 0
			: margin
			? margin
			: `2rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
		padding: padding ? padding : wide ? "0.1rem 2rem" : "0.125rem 0",
		disabledcolor: disabledcolor ? disabledcolor : theme.colors.lightgrey,
		scale: scale ? scale : "1",
		width: fullwidth ? "100%" : wide ? "auto" : width ? width : "180px",
		minwidth: minwidth ? minwidth : "",
		widthsmall: fullwidth ? "100%" : wide ? "100%" : widthsmall ? widthsmall : "100%",
		border: border,
		height: height,
		borderradius: borderradius,
		justifycontent: justifycontent ? justifycontent : "center",
	})
)`
	cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
	span {
		&:hover {
			cursor: ${({ disabled }) => (disabled ? "not-allowed" : "")};
		}
	}
	transition: all 0.2s ease;
	text-decoration: none;
	display: ${({ display }) => display};
	align-items: center;
	justify-content: center;
	backface-visibility: hidden;
	margin-right: ${({ marginright }) => marginright};
	margin-left: ${({ smallmarginleft }) => smallmarginleft};
	padding: ${({ padding }) => padding};
	height: ${({ height }) => height};
	min-width: ${({ minwidth }) => minwidth};
	text-align: center;
	height: ${({ height }) => height};
	overflow: initial;
	border-radius: ${({ borderradius }) => (borderradius ? borderradius : "3px")};
	width: ${({ widthsmall }) => (widthsmall ? widthsmall : "100%")};
	justify-content: ${({ justifycontent }) => justifycontent};
	margin: ${({ smallmargin }) => (smallmargin ? smallmargin : "2rem 0 0 0")};

	${media.greaterThan(breakpoints.mobile)`
		margin: ${({ margin }) => margin};
	  	width: ${({ width }) => (width ? width : "initial")};
	  	margin-left: ${({ marginleft }) => marginleft};
	`}

	&:focus {
		outline-style: solid;
		outline-offset: 5px;
		outline-width: 2px;
		outline-color: ${({ theme }) => theme.colors.focus};
	}

	&:disabled {
		background: ${({ disabledcolor }) => (disabledcolor ? disabledcolor : "")};
		cursor: not-allowed;
	}
`;

export const PrimaryButton = styled(Base).attrs(
	({ inverted, theme, focedBgColor, forcedColor }) => ({
		bgColor: focedBgColor
			? focedBgColor
			: inverted
			? theme.colors.primary
			: theme.colors.none,
		bgColorhover: inverted ? theme.colors.none : theme.colors.primary,
		color: forcedColor ? forcedColor : inverted ? theme.colors.white : theme.colors.black,
		colorhover: inverted ? theme.colors.black : theme.colors.white,
	})
)`
	background-color: ${({ bgColor }) => bgColor};
	border: 2px solid ${({ theme }) => theme.colors.primary};
	span,
	i:before {
		transition: 0.2s ease;
		color: ${({ color }) => color};
	}

	&:hover {
		background-color: ${({ bgColorhover }) => bgColorhover};
		span,
		i:before {
			transition: 0.2s ease;
			color: ${({ colorhover }) => colorhover};
		}
	}
`;
export const ColoredButton = styled(Base)`
	background-color: ${({ bgColor, inverted, theme }) =>
		inverted ? bgColor : theme.colors.none};
	border: ${({ bgColor, theme }) =>
		bgColor ? `2px solid ${bgColor}` : `2px solid ${theme.colors.primary}`};
	span {
		color: ${({ inverted, theme, color }) =>
			color ? color : inverted ? theme.colors.white : theme.colors.black};
	}
	&:hover,
	&:focus {
		background-color: ${({ inverted, bgColor, theme }) =>
			inverted ? theme.colors.none : bgColor};
		span {
			color: ${({ inverted, theme }) =>
				!inverted ? theme.colors.white : theme.colors.black};
		}
	}
`;
export const Button = styled(Base).attrs(
	({
		inverted,
		background,
		textHoverColor,
		borderColor,
		hoverColor,
		light,
		theme,
		textColor,
		textColorHover,
	}) => ({
		bgColor: inverted ? (background ? background : "") : theme.colors.none,
		bgColorhover: hoverColor ? hoverColor : !inverted ? background : theme.colors.none,

		color: textColor ? textColor : inverted ? theme.colors.white : theme.colors.black,
		colorhover: textColorHover
			? textColorHover
			: inverted || light
			? theme.colors.black
			: theme.colors.white,
	})
)`
	background-color: ${({ inverted, background, theme }) =>
		inverted ? background : theme.colors.none};
	border: ${({ background, borderColor }) =>
		borderColor ? `2px solid ${borderColor}` : `2px solid ${background}`};
	span {
		color: ${({ color }) => color};
	}

	&:hover,
	&:focus {
		background-color: ${({ bgColorhover }) => bgColorhover};
		span {
			color: ${({ colorhover }) => colorhover};
		}
	}
`;
export const SecondarySubmitButton = styled(SubmitBase)`
	background-color: ${({ theme }) => theme.colors.none};
	border: ${({ theme }) => `2px solid ${theme.colors.secondary}`};
	transition: 0.2s ease;

	span {
		color: ${({ theme }) => theme.colors.black};
	}

	&:hover,
	&:focus {
		background-color: ${({ theme }) => theme.colors.secondary};
		span {
			color: ${({ theme }) => theme.colors.white};
		}
	}
`;
export const RectangularButton = styled(Base).attrs(
	({ inverted, noBorderHover, noBorderLeftOnHover, theme }) => ({
		bgColor: inverted ? theme.colors.bg1 : theme.colors.primary,
		bgColorhover: inverted ? theme.colors.primary : theme.colors.lightgreen,
		color: inverted ? theme.colors.black : theme.colors.white,
		colorhover: inverted ? theme.colors.white : theme.colors.black,
		heightSmall: inverted ? "40px" : "48px",
		height: height ? height : inverted ? "50px" : "58px",
		borderHover: noBorderHover ? "none" : `1px solid ${theme.colors.grey}`,
		borderLeftHover: noBorderLeftOnHover ? "none" : `1px solid ${theme.colors.grey}`,
	})
)`
	background-color: ${({ bgColor }) => bgColor};
	border: none;

	display: flex;
	justify-content: center;
	align-items: center;
	height: ${({ heightSmall }) => heightSmall};
	border-radius: inherit;
	span {
		color: ${({ color }) => color};
	}

	&:hover {
		background-color: ${({ bgColorhover }) => bgColorhover};
		border: ${({ borderHover }) => borderHover};
		border-left: ${({ borderLeftHover }) => borderLeftHover};
		span {
			color: ${({ colorhover }) => colorhover};
		}
	}

	${media.greaterThan(breakpoints.ipad)`
		height: ${({ height }) => height};
		width: ${({ width }) => (width ? width : "initial")};
  	`}
`;
export const SubmitButton = styled(SubmitBase).attrs(
	({ inverted, noBorderHover, noBorderLeftOnHover, theme, hoverBorder, smallHeight }) => ({
		bgColor: inverted ? theme.colors.lightgreen : theme.colors.primary,
		bgColorhover: inverted ? theme.colors.primary : theme.colors.lightgreen,
		color: inverted ? theme.colors.black : theme.colors.white,
		colorhover: inverted ? theme.colors.white : theme.colors.black,
		heightSmall: smallHeight ? smallHeight : inverted ? "40px" : "48px",
		borderHover: hoverBorder
			? hoverBorder
			: noBorderHover
			? "none"
			: `1px solid ${theme.colors.grey}`,
		// borderLeftHover: hoverBorder
		// 	? hoverBorder
		// 	: noBorderLeftOnHover
		// 	? "none"
		// 	: `1px solid ${theme.colors.grey}`,
	})
)`
	background-color: ${({ bgColor }) => bgColor};
	border-radius: 3px;
	border: 0px;
	width: ${({ width }) => (width ? width : "initial")};
	span,
	i:before {
		transition: 0.2s ease;
		color: ${({ color }) => color};
	}
	&:hover {
		background-color: ${({ theme }) => theme.colors.bg1};
		border: ${({ borderHover }) => borderHover};
		/* border-left: ${({ borderLeftHover }) => borderLeftHover}; */
		span,
		i:before {
			transition: 0.2s ease;
			color: ${({ colorhover }) => colorhover};
		}
	}

	${media.greaterThan(breakpoints.ipad)`
		height: ${({ height }) => height};
  	`}
`;
export const RoundedSubmitButton = styled(SubmitButton)`
	position: absolute;
	right: 0;
	top: 0;
	margin: 0;
	border: ${({ border }) => (border ? border : "")};
	height: 100%;
	width: 5rem;
	border-top-right-radius: 50px;
	border-bottom-right-radius: 50px;
	&:hover {
		background-color: ${({ theme }) => theme.colors.bg1};
		span {
			color: ${({ theme, hoverColor }) => (hoverColor ? hoverColor : theme.colors.black)};
		}
		/* border: 1px solid #8f8f8f; */
		border: ${({ border }) => (border ? border : "")};
	}

	${media.greaterThan(breakpoints.ipad)`
		width: 96px;
		height: 100%;
  `}
`;
export const HeaderButton = styled.button.attrs(({}) => ({
	"aria-expanded": "false",
}))`
	border: none;
	background: transparent;
`;


export const CarouselControl = styled.button`
  width: 46px;
  height: 46px;
  border: 1px solid ${({isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,1)'};
  border-radius: 50%;
  background-color: transparent;
  cursor: pointer;
  transition: 0.5s;

  &:focus {
    outline: none;
  }

  &:hover {
    border: 1px solid ${({theme, isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : theme.colors.primary};

    i {
      color: ${({theme, isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : theme.colors.primary};
    }
  }

  i {
    font-size: 20px;
    color: ${({isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,1)'};
    transition: 0.5s;
  }
`
